module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-61.807859d.woff2";